import internalFetch from "./axios-instance";
import {getAuthorizationHeader} from "../helpers/get-token";

export const getApprovalRateCheckerService = async () => await internalFetch.get(`/awin`, {
    headers: { 'Authorization': getAuthorizationHeader() }
});
